// export const aadhaarPattern = /^\d{12}$/;
export const aadhaarPattern = /^[2-9]{1}[0-9]{3}[0-9]{4}[0-9]{4}$/;
// export const aadhaarPattern = /^\d{12}$/;
// export const aadhaarPattern = /^\d{12}$/;
// export const aadhaarPattern = /^\d{12}$/;

export const licenseRegex = /^([A-Z]{2})(\d{2}|\d{3})[a-zA-Z]{0,1}(\d{4})(\d{7})/;
// export const licenseRegex = /^([A-Z]{2})(\d{2}|\d{3})[a-zA-Z]{0,1}(\d{4})(\d{7})/;
// export const licenseRegex = /^[A-Z]{2}[0-9]{2}(19|20)?[0-9]{2}[0-9]{7}$/;
// export const licenseRegex = /^[A-Z]{2}[0-9]{2}(19|20)?[0-9]{2}[0-9]{7}$/;


export const rationCardRegex = /^[A-Za-z0-9]{6,24}$/;
// export const rationCardRegex = /^[0-9]{12}$/;
// export const rationCardRegex = /^[0-9]{12}$/;
// export const rationCardRegex = /^[0-9]{12}$/;

// export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
// export const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
// export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const emailRegex = /^[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}$/; // ChatGPT generated

export const voterIdRegex = /^[A-Z]{3}[0-9]{7}$/;
// export const voterIdRegex = /^[A-Z]{3}[0-9]{7}$/;
// export const voterIdRegex = /^[A-Z]{3}[0-9]{7}$/;
// export const voterIdRegex = /^[A-Z]{3}[0-9]{7}$/;

export const passportRegex = /^[A-Z]{1}[0-9]{7}$/;
// export const passportRegex = /^[A-Z]{1}[0-9]{7}$/;
// export const passportRegex = /^[A-Z]{1}[0-9]{7}$/;
// export const passportRegex = /^[A-Z]{1}[0-9]{7}$/;

export const mobileRegex = /^[6-9]\d{9}$/;
export const newInfoMobileRegex = /^\d{10,11}$/;
// export const mobileRegex = /^[6-9]\d{9}$/;
// export const mobileRegex = /^[6-9]\d{9}$/;
// export const mobileRegex = /^[6-9]\d{9}$/;

export const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
// export const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
// export const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
// export const panRegex = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;

export const onlyNumericRegex = /^[0-9]*$/;

export const onlyAlphaRegex = /^[A-Za-z ]+$/;

export const rcNumberRegex = /^[A-Za-z]{2}[0-9]{2}[A-Za-z]{2}[0-9]{4}$/;

export const alphaNumericRegex = /^[a-zA-Z0-9 ]+$/;

export const alphaNumericSpecialCharsRegex = /^[a-zA-Z0-9\s_.\-@$#+/&]+$/;

export const alphaNumericWithoutSpace = /^[a-zA-Z0-9]*$/;

export const onlyDigital = /^\d+$/;


















